import Splide from '@splidejs/splide';

Splide.defaults = {
  role: 'group',
  type: 'loop',
  mediaQuery: 'min',
};


document.querySelectorAll('.slider--single .splide')
  .forEach(slider => new Splide(slider, {
    arrows: true,
    pagination: true,
    perPage: 1
  }).mount());

document.querySelectorAll('.slider--single-autoplay .splide')
.forEach(slider => new Splide(slider, {
  arrows: true,
  pagination: true,
  perPage: 1,
  autoplay: true
}).mount());

document.querySelectorAll('.slider--single--with--next-slide-view .splide')
  .forEach(slider => new Splide(slider, {
    arrows: false,
    pagination: true,
    perPage: 1,
    centeredSlides: true,
    loop: true
  }).mount());

document.querySelectorAll('.slider--multiple .splide')
  .forEach(slider => new Splide(slider, {
    arrows: true,
    pagination: true,
    // padding: '0',
    perPage: 1,
    breakpoints: {
      580: {
        gap: '2rem',
        perPage: 2,
      },
      830: {
        gap: '4rem',
      },
      1100: {
        perPage: 3,
      },
    },
  }).mount());

  document.querySelectorAll('.slider--multiple--no--pagination .splide')
  .forEach(slider => new Splide(slider, {
    arrows: true,
    pagination: false,
    // padding: '0',
    perPage: 1,
    breakpoints: {
      580: {
        gap: '2rem',
        perPage: 2,
      },
      830: {
        gap: '4rem',
      },
      1100: {
        perPage: 3,
      },
    },
  }).mount());



  document.querySelectorAll('.slider--multiple--no--pagination--four--slides .splide')
  .forEach(slider => new Splide(slider, {
    arrows: true,
    pagination: false,
    // padding: '0',
    perPage: 1,
    breakpoints: {
      580: {
        gap: '2rem',
        perPage: 2,
      },
      830: {
        gap: '4rem',
      },
      1100: {
        perPage: 3,
      },
      1400: {
        perPage: 4,
      },

    },
  }).mount());


  document.querySelectorAll('.slider--multiple--four--slides .splide')
  .forEach(slider => new Splide(slider, {
    arrows: true,
    pagination: true,
    padding: { left: 20, right: 28 },
    // padding: '0',
    perPage: 1,
    breakpoints: {
      580: {
        gap: '2rem',
        perPage: 2,
      },
      830: {
        gap: '4rem',
      },
      1100: {
        perPage: 3,
      },
      1400: {
        perPage: 4,
      },

    },
  }).mount());


  document.querySelectorAll('.slider--reviews .splide')
  .forEach(slider => new Splide(slider, {
    arrows: false,
    pagination: true,
    padding: { left: 20, right: 28 },
    perPage: 4,
    breakpoints: {
      200: {
        perPage: 1,
      },
      580: {
        gap: '2rem',
        perPage: 2,
      },
      830: {
        gap: '4rem',
      },
      1100: {
        perPage: 3,
      },
      1400: {
        perPage: 4,
      },

    },
  }).mount());



 